import { render } from "./ResellerDetail.vue?vue&type=template&id=c4f4d132&ts=true"
import script from "./ResellerDetail.vue?vue&type=script&lang=ts"
export * from "./ResellerDetail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__